export enum EntityTypes {
  "LLP" = "Limited Liability Partnership (LLP)",
  "SCORP" = "S-Corporation",
  "CCORP" = "C-Corporation",
  "OTHER" = "Other"
}